import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Dropdown from "components/Header/imageComponents/Dropdown";
import useScreenMobile from "hooks/useScreen";

import logo from "assets/images/header/companyLogo.svg";
import contactIcon from "assets/images/header/contact.svg";
import hamburger from "assets/images/header/hamburger.svg";
import menu from "assets/images/header/menu.svg";
import close from "assets/images/header/close.svg";

import { serviceLinks as servicesNav } from "containers/services/serviceLinks";

import "./header.scss";

const Header = () => {
  const [dropActive, setDropActive] = useState(false);
  const [closeActive, setCloseActive] = useState(false);
  const [menuDrop, setMenuDrop] = useState(false);

  const isTab = useScreenMobile({ size: 992 });
  const navigate = useNavigate();

  useEffect(() => {
    if (!isTab) {
      setCloseActive(false);
      setMenuDrop(false);
    }
  }, [isTab]);

  useEffect(() => {
    if (closeActive || dropActive) {
      document.body.style.overflow = "hidden";
      document.addEventListener("click", handleClickOutside);
    } else {
      document.body.style.overflow = "unset";
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [closeActive, dropActive]);

  const handleNavigation = (page) => {
    navigate(page);
    setCloseActive(false);
    setDropActive(false);
    setMenuDrop(false);
  };

  const handleContactClick = (idName) => {
    navigate("/", { replace: true });
    setTimeout(() => {
      const formElement = document.getElementById(idName);
      setCloseActive(false);
      if (formElement) {
        formElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 500);
  };

  const handleClickOutside = (event) => {
    const exportBtn = event.target.closest(".header");
    if (!exportBtn) {
      setCloseActive(false);
    }
  };

  return (
    <>
      <section className="header">
        <div className="container headerContainer">
          <div className="content">
            <div className="logo">
              <button
                type="button"
                className="hdrBtn logoBtn"
                aria-label="Paplaj Software Services home"
                onClick={() => handleNavigation("/")}
              >
                <img src={logo} alt="PAPLAJ SOFTWARE SERVICES" />
              </button>
            </div>
            {!isTab && (
              <div className="nav">
                <button
                  type="button"
                  className="navContent hdrBtn"
                  onClick={() => {
                    navigate("/");
                    window.scrollTo(0, 0);
                  }}
                >
                  Home
                </button>
                <div
                  className="navContent service"
                  onMouseEnter={() => setDropActive(true)}
                  onMouseLeave={() => setDropActive(false)}
                >
                  <div className="displayContent">
                    <button
                      type="button"
                      className="navContent serviceText hdrBtn"
                      style={{ color: dropActive ? "#45C1C5" : "#0E0E0F" }}
                      aria-haspopup="true"
                      aria-expanded={dropActive}
                      onClick={() => setDropActive((v) => !v)}
                    >
                      Services
                    </button>
                    <div className="serviceDrop">
                      <Dropdown
                        fillColor={dropActive ? "#45C1C5" : "#0E0E0F"}
                      />
                    </div>
                  </div>
                  {dropActive && (
                    <div className="dropContent">
                      <div className="dropContainer">
                        {servicesNav.map((service) => (
                          <button
                            type="button"
                            key={service.path}
                            className="dropItems hdrBtn"
                            onClick={() => handleNavigation(service.path)}
                          >
                            <div className="imgSection">
                              <div className="imgDropWrapper">
                                <img
                                  src={service.icon}
                                  alt=""
                                  aria-hidden="true"
                                />
                              </div>
                            </div>
                            <div className="textSection">
                              <p className="title">{service.label}</p>
                              <p className="textContent">{service.desc}</p>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div className="navContent">
                  <button
                    type="button"
                    className="hdrBtn"
                    onClick={() => handleContactClick("offer")}
                  >
                    Our Offerings
                  </button>
                </div>
                <div className="navContent">
                  <button
                    type="button"
                    className="hdrBtn"
                    onClick={() => handleNavigation("/case-studies")}
                  >
                    Case Studies
                  </button>
                </div>
              </div>
            )}
          </div>
          {isTab ? (
            <button
              type="button"
              className="hamburger hdrBtn"
              aria-label={closeActive ? "Close menu" : "Open menu"}
              aria-expanded={closeActive}
              onClick={() => {
                setCloseActive(!closeActive);
                setMenuDrop(false);
              }}
            >
              <img src={closeActive ? close : hamburger} alt="" />
            </button>
          ) : (
            <div className="contact">
              <button
                className="contactBtn"
                onClick={() => handleNavigation("/contact")}
              >
                <img src={contactIcon} alt="contact" />
                <span className="contactText">Contact Us</span>
                <div className="animation"></div>
              </button>
            </div>
          )}

          {isTab && closeActive && (
            <div className="menuModal" onClick={() => setCloseActive(false)}>
              <div
                className={`menu ${closeActive ? "menu-active" : ""}`}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="menuContainer">
                  <div className="menuContent service">
                    <button
                      type="button"
                      className="menuContent offer hdrBtn"
                      onClick={() => {
                        handleContactClick("/");
                        setMenuDrop(false);
                      }}
                    >
                      <div className="text">
                        <p>Home</p>
                      </div>
                    </button>
                    <button
                      type="button"
                      className="topContent hdrBtn"
                      aria-haspopup="true"
                      aria-expanded={menuDrop}
                      onClick={() => setMenuDrop(!menuDrop)}
                    >
                      <div className="text">
                        <p>Services</p>
                      </div>
                      <div className="menuImg">
                        <div className="menuImgWrapper">
                          <img src={menu} alt="" />
                        </div>
                      </div>
                    </button>
                    {menuDrop && (
                      <div className="dropContent">
                        <div className="dropContainer">
                          {servicesNav.map((service) => (
                            <button
                              type="button"
                              key={service.path}
                              className="dropItems hdrBtn"
                              onClick={() => {
                                handleNavigation(service.path);
                                setMenuDrop(false);
                              }}
                            >
                              <div className="imgSection">
                                <div className="imgDropWrapper">
                                  <img
                                    src={service.icon}
                                    alt=""
                                    aria-hidden="true"
                                  />
                                </div>
                              </div>
                              <div className="textSection">
                                <p className="title">{service.label}</p>
                                <p className="textContent">{service.desc}</p>
                              </div>
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <button
                    type="button"
                    className="menuContent offer hdrBtn"
                    onClick={() => {
                      handleContactClick("offer");
                      setMenuDrop(false);
                    }}
                  >
                    <div className="text">
                      <p>Our Offerings</p>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="menuContent offer hdrBtn"
                    onClick={() => {
                      handleNavigation("/case-studies");
                      setMenuDrop(false);
                    }}
                  >
                    <div className="text">
                      <p>Case Studies</p>
                    </div>
                  </button>
                  <div className="menuContent contact contactEdit">
                    <button
                      className="contactBtn"
                      onClick={() => {
                        handleNavigation("/contact");
                        setMenuDrop(false);
                      }}
                    >
                      <img src={contactIcon} alt="contact" />
                      <span className="contactText">Contact Us</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Header;
